import React, { useEffect, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

const LiveMeeting = () => {
    const { instituteId, batchId, meetingRoom } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const jitsiApiRef = useRef(null);
    const toastShownRef = useRef(false);

    useEffect(() => {
        // Reset the toast flag for each new room/session mount
        toastShownRef.current = false;
        
        // Build Jitsi meeting room name if not directly passed
        const roomName = meetingRoom || `PenSense_${batchId}_${Date.now()}`;
        const domain = "meet.jit.si";
        
        const options = {
            roomName: roomName,
            width: "100%",
            height: "100%",
            parentNode: document.querySelector('#jitsi-container'),
            configOverwrite: {
                startWithAudioMuted: true,
                startWithVideoMuted: true,
                disableThirdPartyRequests: true,
                prejoinPageEnabled: false,
            },
            interfaceConfigOverwrite: {
                TOOLBAR_BUTTONS: [
                    'microphone', 'camera', 'closedcaptions', 'desktop', 'fullscreen',
                    'framerates', 'chat', 'raisehand', 'videoquality', 'filmstrip',
                    'invite', 'feedback', 'stats', 'shortcuts',
                    'tileview', 'videobackgroundblur', 'download', 'help', 'mute-everyone',
                    'security', 'hangup'
                ],
            },
        };

        const loadJitsiScript = () => {
            return new Promise((resolve) => {
                if (window.JitsiMeetExternalAPI) {
                    resolve();
                } else {
                    const script = document.createElement("script");
                    script.src = `https://${domain}/external_api.js`;
                    script.async = true;
                    script.onload = resolve;
                    document.body.appendChild(script);
                }
            });
        };

        loadJitsiScript().then(() => {
            // Safety check: avoid re-initializing if already unmounted
            if (document.querySelector('#jitsi-container')) {
                const api = new window.JitsiMeetExternalAPI(domain, options);
                jitsiApiRef.current = api;
                
                api.addEventListener('videoConferenceLeft', () => {
                    if (!toastShownRef.current) {
                        toastShownRef.current = true;
                        toast.info("Meeting ended");
                        
                        // Smart redirection back to source
                        const destination = location.state?.from || `/${instituteId}/lms/batches`;
                        navigate(destination);
                    }
                    api.dispose();
                });
            }
        });

        return () => {
            if (jitsiApiRef.current) {
                jitsiApiRef.current.dispose();
                jitsiApiRef.current = null;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [batchId, meetingRoom, instituteId]);

    return (
        <div style={{ height: 'calc(100vh - 100px)', width: '100%', backgroundColor: '#000', borderRadius: '12px', overflow: 'hidden' }}>
            <div id="jitsi-container" style={{ height: '100%', width: '100%' }} />
        </div>
    );
};

export default LiveMeeting;
